<template>
  <div>
    <div class="notice-box" style="padding: 10px">
      <p class="notice-box__text" v-if="serviceType === 'report'">
        본 CVSS 점수는 해당 취약점에 대해 신고자가 직접 계산한 점수로, KISA
        신고포상제 취약점 평가에 반영되지 않습니다.
      </p>
      <p class="notice-box__text" v-else>
        본 CVSS 점수는 해당 취약점에 대해 제조사 담당자가 직접 계산한 점수로,
        KISA 신고포상제 취약점 평가에 반영되지 않습니다.
      </p>
    </div>
    <form class="table-form">
      <div class="table-form__item">
        <label for="cvss-version" class="table-form__label">CVSS점수</label>
        <div class="table-form__field">
          <span>{{ cvssEval?.cvss ?? "-" }}</span>
        </div>
      </div>
      <div class="table-form__item">
        <label for="severity" class="table-form__label">심각도</label>
        <div class="table-form__field">
          <span>{{ cvssEval?.severity || "-" }}</span>
        </div>
      </div>
    </form>
    <table class="form-table type-block--mobile type-th-none--mobile">
      <colgroup>
        <col width="15%" />
        <col width="12%" />
        <col width="30%" />
        <col width="30%" />
      </colgroup>
      <thead>
        <tr>
          <th scope="colgroup" colspan="4">취약점 항목 평가</th>
        </tr>
      </thead>
      <tbody v-if="cvssEval?.evlItem?.evlScore?.length > 0">
        <template v-for="(item, keyIdx) in cvssEval?.evlItem?.evlScore">
          <tr v-for="(sub, idx) in item.evlScore" :key="sub.scoreNm + keyIdx">
            <th
              v-if="idx === 0"
              scope="row"
              :rowspan="item.evlScore.length"
              class="border-right"
            >
              {{ item.scoreNm }}
            </th>
            <td class="height-46">{{ sub.scoreNm }}({{ sub.evlText }})</td>
            <td class="al height-46" colspan="2">
              <fieldset class="chk_btn__wrap type-col4 type-col3--mobile">
                <legend class="sr-only">{{ sub.scoreNm }} 선택</legend>
                <label
                  class="chk_btn"
                  v-for="(option, optIdx) in sub.evlScore"
                  :key="'opt-' + optIdx"
                  :class="{ 'no-pointer': !edit }"
                >
                  <input
                    type="radio"
                    :name="'radio-' + keyIdx + '-' + idx"
                    :value="option.scoreNm"
                    v-model="sub.pick"
                    @change="onPickChange(sub)"
                  />
                  <span class="chk_btn__display"
                    >{{ option.evlText }} ({{ option.scoreNm }})</span
                  >
                </label>
              </fieldset>
            </td>
          </tr>
        </template>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4" class="no-data alignC">평가체계 정보가 없습니다.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import dc from "@/component/utils/DataChk";

export default {
  name: "VulEval",
  props: {
    modelValue: { type: Object, required: true },
    serviceType: { type: String, required: true }, // 서비스 타입 (report / patch)
    edit: { type: Boolean, required: false }, // 편집 모드 여부
  },
  setup(props, { emit }) {
    const axios = inject("axios");
    const lodash = inject("lodash");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const cvssEval = ref(lodash.cloneDeep(props.modelValue.cvssEval));
    const visibleFormular = ref("");
    const rewardActive = ref(false);
    const severitys = ref(null);

    // methods 정의

    const onPickChange = (sub) => {
      pickScore(sub, visibleFormular);
    };

    const getEvalSysForVul = () => {
      showLoading();

      axios
        .get(`${props.serviceType}/pr/eval/get`)
        .then((res) => {
          if (res.data.resType === "RES_OK" && dc.nullChk(res.data.resList)) {
            Object.assign(cvssEval.value.evlItem, res.data.resList[0]);
          } else {
            alert(
              "평가 체계를 불러오는데 오류가 발생하였습니다.\n관리자에게 문의하세요."
            );
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const pickScore = async (val, visibleFormular) => {
      visibleFormular.value = lodash.cloneDeep(cvssEval.value.evlItem.formula);

      val.score = val.evlScore.find((item) => item.scoreNm === val.pick).score;
      visibleFormular.value = cvssEval.value.evlItem.formula.replaceAll(
        " ",
        ""
      );
      visibleFormular.value = visibleFormular.value.replace(/\*.*$/, "");
      cvssEval.value.evlItem.cmptYn = true; // 접수 시 검증용도로 임시사용

      changeFormular4(visibleFormular);
      if (visibleFormular.value.indexOf("<<") === -1) {
        const score = await getCalc(visibleFormular.value);
        const scoreSplit = score.split(":");
        const cvssScore = parseFloat(scoreSplit[0]).toFixed(1);
        cvssEval.value.cvss = cvssScore;
        selectSeverity();
        cvssEval.value.evlItem.cmptYn = false;
      }
    };
    const changeFormular4 = (visibleFormular) => {
      const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      cvssEval.value.evlItem.evlScore.forEach((ele) => {
        ele.evlScore.forEach((score) => {
          if (score.pick !== null) {
            const raw = String(score.evlText || "");
            const fullNameClean = raw.replaceAll(" ", "").trim();
            const innerName = raw
              .replace(/\(.*?\)/g, "")
              .replaceAll(" ", "")
              .trim();

            const regexFull = new RegExp(
              `<<\\s*${escapeRegExp(fullNameClean)}\\s*>>`,
              "gi"
            );
            if (regexFull.test(visibleFormular.value)) {
              visibleFormular.value = visibleFormular.value.replace(
                regexFull,
                score.pick
              );
              return;
            }

            const regexInnerExact = new RegExp(
              `<<\\s*${escapeRegExp(innerName)}\\s*>>`,
              "gi"
            );
            if (regexInnerExact.test(visibleFormular.value)) {
              visibleFormular.value = visibleFormular.value.replace(
                regexInnerExact,
                score.pick
              );
              return;
            }
          }
        });
      });
    };
    const getCalc = (formular) => {
      const info = {
        formula: formular,
        version: cvssEval.value.evlItem.cvssVer,
      };

      showLoading();

      return axios
        .post(`${props.serviceType}/pr/eval/calc/get`, info)
        .then((res) => {
          if (res.data && res.data.resType === "RES_OK") {
            return res.data.resMsg;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const setSeverity = () => {
      showLoading();
      const url = `${props.serviceType}/pr/eval/severity/get`;

      axios
        .post(url)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            severitys.value = res.data.resList;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const selectSeverity = () => {
      for (const item of severitys.value) {
        const min = Number(item.min);
        const max = Number(item.max);
        if (cvssEval.value.cvss >= min && cvssEval.value.cvss < max) {
          cvssEval.value.severity = item.severity;
        }
      }
    };

    // watch 정의
    watch(
      cvssEval,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          cvssEval: newVal,
        });
      },
      { deep: true }
    );

    // life cycle 정의
    onMounted(() => {
      // if (
      //   cvssEval.value == null ||
      //   Object.keys(cvssEval.value.evlItem).length === 0
      // ) {
      //   getEvalSysForVul();
      // }
      // setSeverity();
    });

    // html에서 사용될 데이터 정의
    return {
      visibleFormular,
      rewardActive,
      onPickChange,
      cvssEval,
    };
  },
};
</script>

<style>
.chk_btn.no-pointer {
  pointer-events: none;
  cursor: default;
}
</style>